module.exports = __webpack_public_path__ + "static/media/3@3x.e8ef66aa.png";